/*
 * AppConstants
 * These are the variables that determine what our central data store (reducer.js)
 * changes in our state. When you add a new action, you have to add a new constant here
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'YOUR_ACTION_CONSTANT';
 */

// The initial application state

export const SERVER_URL = 'https://demo5100262.mockable.io';
export const CURRENT_BID_URL = `${SERVER_URL}/sellerweb/currentbids`;

export const LOGIN_URL = `${SERVER_URL}/sellerweb/login`;
export const SENDING_LOGIN_REQUEST = 'SENDING_LOGIN_REQUEST';
export const SET_AUTH = 'SET_AUTH';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';

export const CHANGE_FORM = 'CHANGE_FORM';
export const SENDING_REQUEST = 'SENDING_REQUEST';

export const SET_CURRENT_BIDS = "SET_CURRENT_BIDS";

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';

export const SET_HOME_SCREEN_LOADING = "SET_HOME_SCREEN_LOADING";

export const SET_SHOW_SIDEBAR = "SET_SHOW_SIDEBAR";
export const SET_ACTIVE_MENU_ITEM = "SET_ACTIVE_MENU_ITEM";

export const SHOW_NOTIFICATION_MESSAGE = 'SHOW_NOTIFICATION_MESSAGE';
export const HIDE_NOTIFICATION_MESSAGE = 'HIDE_NOTIFICATION_MESSAGE';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const CLEAR_LOST_NOTIFICATION = 'CLEAR_LOST_NOTIFICATION';
export const CLEAR_ACCEPTED_NOTIFICATION = 'CLEAR_ACCEPTED_NOTIFICATION';
export const SET_NOTIFICATION_POLL_TIME = 'SET_NOTIFICATION_POLL_TIME';

export const SET_SELLER_SERVICES = 'SET_SELLER_SERVICES';
export const SET_PROFILE_COMPLETED = 'SET_PROFILE_COMPLETED';
export const SET_ACTIVE_SUBSCRIPTION_COUNT = 'SET_ACTIVE_SUBSCRIPTION_COUNT';
export const SET_IN_ACTIVE_SUBSCRIPTION_COUNT = 'SET_IN_ACTIVE_SUBSCRIPTION_COUNT';
export const SET_DISABLE_SELLER_REDIRECTION = "SET_DISABLE_SELLER_REDIRECTION";
export const SET_TOS_SIGNED = "SET_TOS_SIGNED";

export const SET_TOS_ENABLED = "SET_TOS_ENABLED";